/** * Created by liguochen on 2019/08/14 */
<template>
  <el-date-picker
    v-model="date"
    :type="dateType"
    class="date_picker"
    :popper-class="className"
    range-separator="-"
    :format="format"
    size="small"
    :value-format="format"
    :picker-options="pickerOptions"
    :clearable="clearable"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    @change="dateChange"
    :default-value="defaultValue"
    :default-time="['00:00:00', '23:59:59']"
  ></el-date-picker>
</template>

<script>
import { messageTips } from "@api/utils";

export default {
  name: "datePicker",
  props: {
    defaultValue: {
      type: Array
    },
    reset: {
      type: Boolean
    },
    clearable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    maxInterval: {
      type: Number,
      default: 120
    },
    disablededTime: {
      type: String
    },
    dateType: {
      type: String,
      default: "daterange"
    },
    format: {
      type: String,
      default: "yyyy-MM-dd"
    },
    className: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      date: [],
      pickerOptions: this.extraDisabled()
    };
  },
  mounted() {
    this.setDefaultDate();
  },
  watch: {
    reset() {
      this.setDefaultDate();
    }
  },
  methods: {
    extraDisabled() {
      const _this = this;
      const endOfTheDay = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      return {
        disabledDate(time) {
          if (_this.disablededTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(_this.disablededTime).getTime()
            );
          }
          return (
            // 当前时间戳大于当天23:59:59
            time.getTime() > endOfTheDay
          );
        },
        shortcuts: _this.disablededTime
          ? null
          : [
              {
                text: "最近一周",
                onClick(picker) {
                  const start = new Date(new Date().toLocaleDateString());
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit("pick", [start, endOfTheDay]);
                }
              },
              {
                text: "最近一个月",
                onClick(picker) {
                  const start = new Date(new Date().toLocaleDateString());
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit("pick", [start, endOfTheDay]);
                }
              },
              {
                text: "最近三个月",
                onClick(picker) {
                  const start = new Date(new Date().toLocaleDateString());
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit("pick", [start, endOfTheDay]);
                }
              }
            ]
      };
    },
    setDefaultDate() {
      if (
        this.defaultValue &&
        Array.isArray(this.defaultValue) &&
        this.defaultValue.length > 1
      ) {
        this.date = [this.defaultValue[0], this.defaultValue[1]];
      } else {
        this.date = undefined;
      }
      this.$emit("input", this.date);
    },
    dateChange(val) {
      if (val) {
        const dateDiff =
          (new Date(val[1]) - new Date(val[0])) / (24 * 3600 * 1000);
        if (dateDiff > this.maxInterval) {
          messageTips(this, "error", `时间跨度不能超过${this.maxInterval}天！`);
        }
        this.$emit("input", this.date);
      } else {
        this.$emit("input", []);
      }
    }
  }
};
</script>

<style lang="scss"></style>
